import React, { useContext } from 'react'
import AppContext from '../context/Context'
import MarketplaceRoutes from '../routes/MarketplaceRoutes'

const MarketplaceLayout = () => {
  const { isFluid } = useContext(AppContext)

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      <MarketplaceRoutes />
    </div>
  )
}

export default MarketplaceLayout
